const data = {
  'Selected': 'المحدد: {0} من {1}',
  'Uploading files': 'تحميل {0}% من {1}',
  'File size error': '{0} كبير جدًا ، يرجى تحميل ملفات أقل من {1}',
  'Upload failed': '{0} فشل التحميل',
  'Per page': '{0} لكل صفحة',
  'Folder': 'مجلد',
  'Login failed, please try again': 'فشل تسجيل الدخول, يرجى المحاولة مرة أخرى',
  'Already logged in': 'قمت بتسجيل الدخول بالفعل.',
  'Please enter username and password': 'الرجاء إدخال اسم المستخدم وكلمة المرور.',
  'Not Found': 'غير موجود',
  'Not Allowed': 'غير مسموح',
  'Please log in': 'يرجى تسجيل الدخول',
  'Unknown error': 'خطأ غير معروف',
  'Add files': 'إضافة ملفات',
  'New': 'جديد',
  'New name': 'اسم جديد',
  'Username': 'اسم المستخدم',
  'Password': 'كلمة المرور',
  'Login': 'تسجيل الدخول',
  'Logout': 'تسجيل الخروج',
  'Profile': 'الملف الشخصي',
  'No pagination': 'لا ترقم الصفحات',
  'Time': 'الوقت',
  'Name': 'الإسم',
  'Size': 'الحجم',
  'Home': 'الرئيسية',
  'Copy': 'نسخ',
  'Move': 'نقل',
  'Rename': 'إعادة التسمية',
  'Required': 'هذا الحقل مطلوب',
  'Zip': 'Zip',
  'Batch Download': 'تحميل جماعي',
  'Unzip': 'استخراج',
  'Delete': 'حذف',
  'Download': 'تنزيل',
  'Copy link': 'نسخ الرابط',
  'Done': 'تم',
  'File': 'ملف',
  'Drop files to upload': 'قم بإسقاط الملفات لتحميلها',
  'Close': 'إغلاق',
  'Select Folder': 'تحديد المجلد',
  'Users': 'المستخدمين',
  'Files': 'الملفات',
  'Role': 'قاعدة',
  'Cancel': 'إلغاء',
  'Paused': 'إيقاف',
  'Confirm': 'تأكيد',
  'Create': 'إنشاء',
  'User': 'المستخدم',
  'Admin': 'المدير',
  'Save': 'حفظ',
  'Read': 'قراءة',
  'Write': 'كتابة',
  'Upload': 'رفع',
  'Permissions': 'أذونات',
  'Homedir': 'المجلد الرئيسي',
  'Leave blank for no change': 'اتركه فارغا بدون تغيير',
  'Are you sure you want to do this?': 'هل انت متأكد من أنك تريد أن تفعل هذا؟',
  'Are you sure you want to allow access to everyone?': 'هل أنت متأكد من أنك تريد إتاحة الوصول للجميع؟',
  'Are you sure you want to stop all uploads?': 'هل أنت متأكد أنك تريد إيقاف جميع عمليات التحميل؟',
  'Something went wrong': 'هناك خطأ ما',
  'Invalid directory': 'مجلد غير صالح',
  'This field is required': 'هذا الحقل مطلوب',
  'Username already taken': 'الاسم مستخدم بالفعل',
  'User not found': 'لم يتم العثور على هذا المستخدم',
  'Old password': 'كلمة المرور القديمة',
  'New password': 'كلمة المرور الجديدة',
  'Wrong password': 'كلمة مرور خاطئة',
  'Updated': 'تم التحديث',
  'Deleted': 'تم الحذف',
  'Your file is ready': 'ملفك جاهز',
  'View': 'عرض',
  'Search': 'البحث',
  'Download permission': 'صلاحيات التنزيل',
  'Guest': 'زائر',
  'Show hidden': 'إظهار المخفي',
  'Show symbolic format': 'إظهار التنسيق الرمزي',
  'Hide symbolic format': 'إخفاء التنسيق الرمزي',
}

export default data

